import React from 'react'

import './typping.scss'

export const Typping = () => (
  <div className="ticontainer">
    <div className="tiblock">
      <div className="tidot"></div>
      <div className="tidot"></div>
      <div className="tidot"></div>
    </div>
  </div>
)
